import React, {useEffect, useState} from "react";
import {useStyles} from "../styles/EvenSpeakingStyle";
import {
    Box,
    Button, TextField,
    Typography,
} from "@material-ui/core";
import clsx from "clsx";
import {withRouter} from "react-router-dom";
import {inject, observer} from "mobx-react";
import EduLangTabs from "../../../../../../components/EduLangTabs";
import EvenSpeakingSentence from "./EvenSpeakingSentence";

function EvenStepSix(props) {
    const classes = useStyles();

    const [boldSearchText, setBoldSearchText] = useState('');
    const { contentStore, evenStepSixStore } = props;
    const { contentTapIndex, selectedContent, isProcessing } = evenStepSixStore;

    useEffect(() => {
        evenStepSixStore.getEvenStepSixContent(contentStore.stepValue, contentStore.dayValue);
        contentStore.setOnSave(onSave);
        return ()=> {
            contentStore.setOnSave(null);
            evenStepSixStore.initEvenStepSixContent(contentStore.stepValue, contentStore.dayValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSave = () => {
        evenStepSixStore.modifyEvenStepSixContent(contentStore.stepValue, contentStore.dayValue);
    }

    const handleClickBoldEdit = () => {
        evenStepSixStore.setProcessing(true);
    }

    const handleClickFinishBoldEdit = () => {
        evenStepSixStore.setProcessing(false);
    }

    const handleTabChange = (event, newValue) => {
        evenStepSixStore.setContentTapIndex(newValue);
        // setBoldSearchText("");
        handleClickFinishBoldEdit();
    }

    const boldBatchChange = () => {
        const {contents} = selectedContent;
        evenStepSixStore.setBoldBatchChange(contents, boldSearchText);
    }


    return (
        <div className={classes.root}>
            {isProcessing &&
                <Box className={classes.boxRole}>
                    <Box display={'flex'} alignItems={'flex-start'} justifyContent={'flex-start'} position={'relative'}>
                        <Box display={'flex'} alignItems={'center'} justifyContent={'center'} sx={{marginRight: 110}}>
                            <Typography className={classes.typeOption}>볼드 수정</Typography>
                            <Box className={classes.textName}>
                                <TextField id="outlined-basic-bolded-text"
                                           variant="outlined"
                                           placeholder="수정 검색어 입력"
                                           onChange={(e) => setBoldSearchText(e.target.value)}
                                           value={boldSearchText}
                                />
                            </Box>
                            <Box className={clsx(classes.boldUncomplete, classes.boldComplete)}>
                                <Button disableRipple onClick={boldBatchChange}>
                                    <Typography>일괄 적용</Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            }
            <Box className={clsx(classes.boxWrap, classes.heightStep1)}>
                <Box>
                    <Box position="static" className={classes.tabBox}>
                        <EduLangTabs value={contentTapIndex} handleChange={handleTabChange}/>
                    </Box>
                    <Box className={classes.textBox}>
                        <EvenSpeakingSentence selectedContent={selectedContent}/>

                        <Box display={"flex"} justifyContent={"flex-end"} className={classes.buttonBox}>
                            {isProcessing ?
                                <Box className={clsx(classes.uncomplete, classes.complete)}>
                                    <Button disableRipple onClick={handleClickFinishBoldEdit}>
                                        <Typography>완료</Typography>
                                    </Button>
                                </Box> :
                                <Box className={clsx(classes.boldUncomplete, classes.boldComplete)}>
                                    <Button disableRipple onClick={handleClickBoldEdit}>
                                        <Typography>볼드 수정</Typography>
                                    </Button>
                                </Box>
                            }
                        </Box>
                    </Box>
                </Box>
            </Box>
        </div>
    );
}

export default withRouter(inject('contentStore','evenStepSixStore')(observer(EvenStepSix)));
